export const RECEPTION_TYPE = {
  UNPROCESSED: 1,
  IN_PROCESS: 2,
  PAUSED: 3,
  EMPTIED: 4,
};

export const RECEPTION_TYPE_LABEL: Record<number, string> = {
  [RECEPTION_TYPE.UNPROCESSED]: 'Sin procesar',
  [RECEPTION_TYPE.IN_PROCESS]: 'En proceso',
  [RECEPTION_TYPE.PAUSED]: 'Pausado',
  [RECEPTION_TYPE.EMPTIED]: 'Vaciado',
}

export const RECEPTION_TYPE_COLOR: Record<number, 'secondary' | 'warning' | 'info' | 'success'> = {
  [RECEPTION_TYPE.UNPROCESSED]: 'secondary',
  [RECEPTION_TYPE.IN_PROCESS]: 'info',
  [RECEPTION_TYPE.PAUSED]: 'warning',
  [RECEPTION_TYPE.EMPTIED]: 'success',
}

export const RECEPTION_TYPES = [
  { name: RECEPTION_TYPE_LABEL[RECEPTION_TYPE.UNPROCESSED], value: RECEPTION_TYPE.UNPROCESSED },
  { name: RECEPTION_TYPE_LABEL[RECEPTION_TYPE.IN_PROCESS], value: RECEPTION_TYPE.IN_PROCESS },
  { name: RECEPTION_TYPE_LABEL[RECEPTION_TYPE.PAUSED], value: RECEPTION_TYPE.PAUSED },
  { name: RECEPTION_TYPE_LABEL[RECEPTION_TYPE.EMPTIED], value: RECEPTION_TYPE.EMPTIED },
]